module.exports = __webpack_public_path__ + "img/Alexa-Alejandre.d5f65ec4.jpg";